import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/693885e0cbbd900013cf915f/food_for_thought_foundation/src/app/homepage/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/693885e0cbbd900013cf915f/food_for_thought_foundation/src/app/impact/components/ImpactInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/693885e0cbbd900013cf915f/food_for_thought_foundation/src/components/common/Header.tsx");
